/**
 * WG Quick Order — traffic-light inventory status without exact counts.
 *
 * WG inventory appears as text like "10 left" in table cells. We parse counts
 * to classify into traffic-light bands, then replace the visible text with
 * qualitative labels only.
 *
 * Uses debounced MutationObserver scoped to .wsg-proxy-container only.
 * Never observes document.body to avoid performance issues on other pages.
 */
(function () {
  var config = window.PB_B2B_CONFIG || {};
  var greenThreshold = parseInt(config.inventoryGreenThreshold, 10) || 20;
  var yellowThreshold = parseInt(config.inventoryYellowThreshold, 10) || 5;
  var LABELS = {
    green: 'In stock',
    yellow: 'Low stock',
    red: 'Limited stock'
  };

  var LEFT_RE = /^(\d+)\s+left\.?$/i;
  var processing = false;
  var debounceTimer = null;

  function inventoryLeafElements(container) {
    var out = [];
    var all = container.querySelectorAll('td, span, div, p, small');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var t = el.textContent.trim();
      var m = t.match(LEFT_RE);
      var count = m ? parseInt(m[1], 10) : NaN;

      if (isNaN(count) && el.dataset && el.dataset.invCount) {
        count = parseInt(el.dataset.invCount, 10);
      }
      if (isNaN(count)) continue;

      // Skip if a child already matched (avoid double-processing)
      var hasChildWithSame = false;
      for (var c = el.firstElementChild; c; c = c.nextElementSibling) {
        if (LEFT_RE.test(c.textContent.trim()) || (c.dataset && c.dataset.invCount)) {
          hasChildWithSame = true;
          break;
        }
      }
      if (hasChildWithSame) continue;
      out.push({ el: el, count: count });
    }
    return out;
  }

  function classifyRows() {
    if (processing) return;
    var container = document.querySelector('.wsg-proxy-container');
    if (!container) return;

    processing = true;
    var items = inventoryLeafElements(container);
    items.forEach(function (item) {
      var el = item.el;
      var count = item.count;
      el.classList.remove('inv-green', 'inv-yellow', 'inv-red', 'inv-badge');
      if (count >= greenThreshold) {
        el.classList.add('inv-green');
      } else if (count >= yellowThreshold) {
        el.classList.add('inv-yellow');
      } else {
        el.classList.add('inv-red');
      }
      el.classList.add('inv-badge');
      if (el.dataset) {
        el.dataset.invCount = String(count);
      }
      el.textContent = LABELS[
        count >= greenThreshold ? 'green' : count >= yellowThreshold ? 'yellow' : 'red'
      ];
    });
    processing = false;
  }

  function debouncedClassify() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(classifyRows, 500);
  }

  var observer = new MutationObserver(function () {
    if (!processing) debouncedClassify();
  });

  function init() {
    var container = document.querySelector('.wsg-proxy-container');
    if (!container) return; // No proxy container — do nothing, never observe body
    observer.observe(container, { childList: true, subtree: true });
    classifyRows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
